import React from 'react';

function AppShare({ description, shareUrl = null, title = 'FIRE Rankings' }) {
    shareUrl = shareUrl ? shareUrl : window.location.href;

    const shareTwitter = () => {
        const text = description;
        const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`;
        window.open(url, 'twitter-share', 'width=600,height=400');
    };

    const shareBluesky = () => {
        // Bluesky's compose intent has no separate URL param, so the link must
        // be embedded in the text (same as scripts/share.js does).
        const text = `${description} ${shareUrl}`;
        const url = `https://bsky.app/intent/compose?text=${encodeURIComponent(text)}`;
        window.open(url, 'bluesky-share', 'width=600,height=400');
    };

    const shareFacebook = () => {
        const text = description;
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(text)}`;
        window.open(url, 'facebook-share', 'width=600,height=400');
    };

    const shareLinkedIn = () => {
        const text = description;
        const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&summary=${encodeURIComponent(text)}`;
        window.open(url, 'linkedin-share', 'width=600,height=400');
    };

    const shareEmail = () => {
        const subject = title;
        const body = `Check out the FIRE Rankings: ${shareUrl}`;
        const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoUrl;
    };

    return (
        <div className="site-social-share">
            <span className="share-title">Share </span>
            <ul className="social-links">
                <li className="social-item">
                    <button
                        className="social-link"
                        title="Share on Twitter/X"
                        onClick={() => shareTwitter()}
                    >
                        <span className="sr-only">Share on Twitter/X</span>
                        <svg className="social-icon" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M18.3287 2.7998H21.7021L14.3323 11.2231L23.0023 22.6852H16.2137L10.8967 15.7335L4.81277 22.6852H1.43735L9.32014 13.6756L1.00293 2.7998H7.96385L12.77 9.15396L18.3287 2.7998ZM17.1448 20.6661H19.014L6.94816 4.71288H4.94228L17.1448 20.6661Z"></path></svg>
                    </button>
                </li>
                <li className="social-item">
                    <button
                        className="social-link"
                        title="Share on Bluesky"
                        onClick={() => shareBluesky()}
                    >
                        <span className="sr-only">Share on Bluesky</span>
                        <svg className="social-icon" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M11.9925 11.7694C10.9709 9.78993 8.19966 6.09285 5.62001 4.27305C3.14891 2.52987 2.20389 2.82997 1.5909 3.11093C0.875752 3.43658 0.748047 4.53484 0.748047 5.17976C0.748047 5.82467 1.09924 10.4795 1.33549 11.2522C2.10173 13.819 4.81547 14.6874 7.3185 14.4065C7.4462 14.3873 7.57391 14.3682 7.708 14.3554C7.58029 14.3746 7.4462 14.3937 7.3185 14.4065C3.65335 14.9492 0.390472 16.2838 4.66861 21.0408C9.36817 25.9064 11.1114 20 12.0053 16.9989C12.8992 19.9936 13.9273 25.6893 19.2526 21.0408C23.2561 16.9989 20.3508 14.9492 16.6857 14.4065C16.558 14.3937 16.4239 14.3746 16.2962 14.3554C16.4303 14.3746 16.558 14.3873 16.6857 14.4065C19.1887 14.6874 21.9089 13.819 22.6687 11.2522C22.8986 10.4732 23.2561 5.82467 23.2561 5.17976C23.2561 4.53484 23.1284 3.43658 22.4133 3.11093C21.7939 2.82997 20.8553 2.52987 18.3842 4.27305C15.7854 6.09924 13.0142 9.78993 11.9925 11.7694Z"></path></svg>
                    </button>
                </li>
                <li className="social-item">
                    <button
                        className="social-link"
                        title="Share on Facebook"
                        onClick={() => shareFacebook()}
                    >
                        <span className="sr-only">Share on Facebook</span>
                        <svg className="social-icon" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M12.0016 0.895508C5.37445 0.895508 0.00195312 6.268 0.00195312 12.8952C0.00195312 18.5225 3.87641 23.2447 9.10298 24.5416V16.5623H6.62865V12.8952H9.10298V11.3151C9.10298 7.23085 10.9514 5.33779 14.9612 5.33779C15.7215 5.33779 17.0333 5.48706 17.57 5.63586V8.95977C17.2868 8.93001 16.7948 8.91513 16.1837 8.91513C14.2163 8.91513 13.456 9.66055 13.456 11.5983V12.8952H17.3756L16.7021 16.5623H13.456V24.807C19.3977 24.0894 24.0018 19.0304 24.0018 12.8952C24.0013 6.268 18.6288 0.895508 12.0016 0.895508Z"></path></svg>
                    </button>
                </li>
                <li className="social-item">
                    <button
                        className="social-link"
                        title="Share on LinkedIn"
                        onClick={() => shareLinkedIn()}
                    >
                        <span className="sr-only">Share on LinkedIn</span>
                        <svg className="social-icon" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M22.2238 0.895508H1.7728C0.793142 0.895508 0.000976562 1.66892 0.000976562 2.62515V23.1605C0.000976562 24.1167 0.793142 24.8948 1.7728 24.8948H22.2238C23.2035 24.8948 24.0003 24.1167 24.0003 23.1652V2.62515C24.0003 1.66892 23.2035 0.895508 22.2238 0.895508ZM7.12109 21.3465H3.55869V9.89057H7.12109V21.3465ZM5.33989 8.32968C4.19617 8.32968 3.27276 7.40627 3.27276 6.26723C3.27276 5.1282 4.19617 4.20479 5.33989 4.20479C6.47892 4.20479 7.40234 5.1282 7.40234 6.26723C7.40234 7.40158 6.47892 8.32968 5.33989 8.32968ZM20.452 21.3465H16.8943V15.7779C16.8943 14.4514 16.8708 12.7405 15.0428 12.7405C13.1912 12.7405 12.91 14.1889 12.91 15.6842V21.3465H9.35697V9.89057H12.7694V11.4562H12.8162C13.2897 10.5562 14.4521 9.60464 16.1818 9.60464C19.7864 9.60464 20.452 11.9765 20.452 15.0607V21.3465Z"></path></svg>
                    </button>
                </li>
                <li className="social-item">
                    <button
                        className="social-link"
                        title="Share via Email"
                        onClick={() => shareEmail()}
                    >
                        <span className="sr-only">Email</span>
                        <svg className="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" role="img"><title>Email</title><path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7 .3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2 .4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"/></svg>
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default AppShare;
